<!-- <app-navbar></app-navbar> -->
<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<div class="talentpool-insights">
  <div>

    <div class="row">
      <div class="col-md-8" style="padding-right: 12px;">

        <div class="wccard insights-header">
          Make informed talent decisions with
          <p> Talent Pool Insights. </p>
        </div>

        <ul class="nav nav-pills wccard" style="margin: 8px 0px !important;">
          <li class="nav-item">
            <a data-testid="auto-app-talentpool-insights-a-1" class="nav-link active" id="pills-jdsearch-tab" (click)="onTabChange(INSIGHTS_TAB.JD_SEARCH)" data-bs-toggle="pill" aria-selected="false"
              href="#pills-jdsearch" role="tab" aria-controls="pills-jdsearch"><i
                class="fa-solid fa-stars"></i> Job Description</a>
          </li>

          <li class="nav-item">
            <a data-testid="auto-app-talentpool-insights-a-2" class="nav-link" id="pills-quicksearch-tab" (click)="onTabChange(INSIGHTS_TAB.QUICK_SEARCH)"
              data-bs-toggle="pill" href="#pills-quicksearch" role="tab" aria-controls="pills-quicksearch" aria-selected="true"
              >
              Quick Search
            </a>
          </li>
        </ul>

        <!-- jd search tab -->
        <div class="">
          <div *ngIf="currentTab == INSIGHTS_TAB.JD_SEARCH" class="tab-pane show" id="pills-jdsearch" role="tabpanel"
            aria-labelledby="pills-jdsearch-tab">
            <div class="">
              <app-jd-search></app-jd-search>
            </div>
          </div>

          <!-- Quick search tab -->
           <div *ngIf="currentTab == INSIGHTS_TAB.QUICK_SEARCH" class="tab-pane " id="pills-quicksearch"
           role="tabpanel" aria-labelledby="pills-quicksearch-tab">
            <div class="wccard quickSearch">
              <ng-template [ngTemplateOutlet]="quickSearch"></ng-template>
            </div>
          </div>
        </div>
      </div>


      <div class="col" style="padding-left:0px;">
        <div *ngIf="currentTab == INSIGHTS_TAB.QUICK_SEARCH" class="talent-count" style="height: 130px;">
          <div class="talent-count-background" *ngIf="!totalCandidatesCountLoading">
            <p class="f-18 font-weight-normal mb-2  text-342a29">Total available talents</p>
            <p class="f-35 font-weight-600 text-342a29 pb-4">
              {{formatNumberToIndianFormat(totalCandidatesCount)}}
            </p>
          </div>

          <div class="wccard result-section d-flex justify-content-center" *ngIf="totalCandidatesCountLoading">
            <img style="width: 100px;" src="../../../../assets/images/animation_lkl59h1l_small.gif" alt="Loading">
          </div>
        </div>

        <div *ngIf="currentTab == INSIGHTS_TAB.JD_SEARCH" class="talent-jd" style="height: 130px;">
          <div class="talent-count-background" style="height: 100%;">
            <p class="f-12" style="margin-bottom: 8px;">Real-time AI Insights & Intelligence</p>
            <p class="font-weight-600 f-16" style="width: 75%;">83% of recruiters have greatly reduced sourcing time
              with our AI-driven JD search.</p>
          </div>
        </div>
        <div class="search-history">
          <app-search-history currentModule="talent-insights"></app-search-history>
        </div>

        <div class="search-history">
          <app-search-history currentModule="talent-insights" save=true></app-search-history>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Quick search template -->
<ng-template #quickSearch>
  <div class="wccard">
    <div class="d-flex justify-content-between mb-2">
      <p class="f-14 font-weight-500  text-342a29">What is the talent’s title or skill? <span
          class="text-9696 f-10 font-weight-normal"> (One or both, either option is acceptable)</span></p>
      <span class="text-webbtree-green f-14 font-weight-500 pointer" (click)="resetFilters()">
        Reset
      </span>
    </div>
    <div class="mb-5 d-flex align-items-start">
      <div>
        <div style="width: 80px; margin-top: 5px;">
          Title
        </div>
      </div>

      <div class="w-100">
        <input data-testid="auto-app-talentpool-insights-input-1" type="text" name="" class="wc-form-control no-shadow w-100 inputheight mb-2"
          [formControl]="jobTitleInput" (input)="onTypeAheadSearch($event, 'jobtitle')"
          placeholder="Enter Job Title...." [matAutocomplete]="jobtitle_auto"
          (keyup.enter)="selectedItem($event.target.value, 'jobtitle', 'enter')" (blur)="removeTypeahead('jobtitle')">

        <mat-autocomplete #jobtitle_auto="matAutocomplete"
          (optionSelected)="selectedItem($event.option.value, 'jobtitle')">
          <mat-option *ngFor="let jt of jobTitleList" [value]="jt">
            <span class="d-flex align-items-center">
              <span class="text-truncate">{{jt.value | titlecase}}</span>
            </span>
          </mat-option>
        </mat-autocomplete>
        <div class="mt-2">
          <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let jobtitle of jobTitleSelectedList"
            [ngStyle]="{ 'background-color': jobtitle?.isSuggestion ? 'rgba(226, 78, 127, 0.05)' : '#fffff' }">
            <div class="d-flex">
              <span style="display: grid;">
                <span class="text-truncate">
                  {{jobtitle?.chipkey | titlecase}}
                </span>
              </span>
              <span class="ml-2 pointer " (click)="removeChip(jobtitle?.chipkey , 'jobtitle')">
                <i class="fal fa-times"></i></span>
            </div>
          </span>
        </div>
        <!-- jobtitle ai suggestions -->
        <div class="d-flex align-items-center">
          <div *ngIf="showOpenAITitleSuggestions && !isOpenAITitleLoading"
            class="pr-2 flex-shrink-0 border-right d-flex h-100 align-self-start">
            <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500">
              <i class="fa fa-stars"
                matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="right"
                style="color: #b500ff;"></i>
            </span>
          </div>
          <div *ngIf="isOpenAITitleLoading" class="shimmer-loader"
            style="height: 23px; width: 300px; border-radius: 10px;"></div>
          <div class="overflow-hidden pl-2 w-100">
            <openai-suggested-titles [removeSelected]="true" [onlyExisiting]="true" showOnly="titles"
              [showIcons]="false" [continent]="[showregion]" [showCount]="false" (change)="setTitleSuggestions($event)"
              (loading)="openaiTitleLoading($event)" [query]="openAIAll" [updateChips]="updatedAiTitleChips"
              [exclude]="openAIExcludeJobTitles" [maxChips]="5" [keepSuggestions]="true"
              [titleAggregateType]="jobTitleAggregateType" [titleType]="jobTitleType" [jobtitleAndSkillAIData] = "jobtitleAndSkillAIData">
            </openai-suggested-titles>
          </div>
        </div>

      </div>
    </div>
    <div class="mb-5 d-flex align-items-start">
      <div>
        <div style="width: 80px; margin-top: 5px;">
          Skills
        </div>
      </div>

      <div class="w-100">
        <input data-testid="auto-app-talentpool-insights-input-2" type="text" name="" class="wc-form-control  no-shadow w-100 inputheight mb-2" placeholder="Enter Skills"
          [formControl]="skillsInput" (keyup.enter)="selectedItem($event.target.value, 'skills', 'enter')"
          (input)="onTypeAheadSearch($event, 'skills')" [matAutocomplete]="skills_auto"
          (blur)="removeTypeahead('skills')">
        <mat-autocomplete #skills_auto="matAutocomplete" (optionSelected)="selectedItem($event.option.value, 'skills')">
          <mat-option *ngFor="let s of skillsList" [value]="s">
            <span class="d-flex align-items-center">
              <span class="text-truncate">{{s.value | titlecase}}</span>
            </span>
          </mat-option>
        </mat-autocomplete>
        <div class="mt-2">
          <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let s of skillsSelectedList"
            [ngStyle]="{ 'background-color': s?.isSuggestion ? 'rgba(226, 78, 127, 0.05)' : '#fffff' }">
            <div class="d-flex">
              <span style="display: grid;">
                <span class="text-truncate">
                  {{s?.chipkey | titlecase}}
                </span>
              </span>
              <span class="ml-2 pointer " (click)="removeChip(s?.chipkey , 'skills')">
                <i class="fal fa-times"></i></span>
            </div>
          </span>
        </div>

        <!-- skills ai suggestions -->
        <div class="d-flex align-items-center">
          <div *ngIf="showOpenAISkillsSuggestions && !isOpenAISkillsLoading"
            class="pr-2 flex-shrink-0 border-right d-flex h-100 align-self-start">
            <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500">
              <i class="fa fa-stars"
                matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="right"
                style="color: #b500ff;"></i>
            </span>
          </div>
          <div *ngIf="isOpenAISkillsLoading" class="shimmer-loader"
            style="height: 23px; width: 300px; border-radius: 10px;"></div>
          <div class="overflow-hidden pl-2 w-100">
            <openai-suggested-titles [removeSelected]="true" [onlyExisiting]="true" showOnly="skills"
              [showIcons]="false" [continent]="[showregion]" [showCount]="false" (change)="setSkillsSuggestions($event)"
              (loading)="openaiSkillsLoading($event)" [query]="openAIAll" [updateChips]="updatedAiSkillChips"
              [exclude]="openAIExcludeSkills" [removeSelected]="true" [maxChips]="5" [keepSuggestions]="true" [jobtitleAndSkillAIData] = "jobtitleAndSkillAIData">
            </openai-suggested-titles>
          </div>
        </div>

      </div>
    </div>

    <div class="mb-6">
      <div class="card" style="border: 1px solid #e4f1f3; border-left: none; border-right: none;">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0 f-14">
            <div class="px-0 w-100">
              <div class="f-14  w-100">
                <div class="d-flex  w-100 align-items-baseline">
                  <button data-testid="auto-app-talentpool-insights-button-1" id="collapseOneBtn"
                    class="static btn font-weight-500 flex-grow-1 text-left  f-14 ml--7 f-14 text-342a29"
                    [ngClass]="{'collapsed': true}" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    [attr.aria-expanded]="true" aria-controls="collapseOne">
                    Add Keyword or Boolean search
                  </button>
                  <label for="collapseOneBtn" class="toggle text-webbtree-green">
                    <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                    <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
                  </label>
                </div>
              </div>
            </div>
          </h5>
        </div>

        <div id="collapseOne" class="collapse" [ngClass]="{'show': this.keywordsearch}" aria-labelledby="headingOne">
          <div class="position-relative mt-1 d-flex align-items-baseline">
            <div class="mr-5">Search</div>
            <div class="w-100">
              <input data-testid="auto-app-talentpool-insights-input-3" class="wc-form-control no-shadow w-100 inputheight mb-2" [formControl]="keywordInput"
                (click)="searchDisable=true;" [readonly]="!searchDisable"
                [ngClass]="{'disabled-input': (!searchDisable), 'enable-input': searchDisable}"
                (keyup.enter)="selectedValue(keywordInput.value);searchDisable=false;"
                placeholder="Keyword or boolean search using Job Title, Skill, Name, Company or Industry…">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3 mt-7 f-14 font-weight-500 d-flex justify-content-between">
      <div class="">
        From which locations are you interested looking for talent?
      </div>

      <!-- <span class="dropdown ats-dropBtn">
        <button data-testid="auto-app-talentpool-insights-button-2" class=" dropdown-toggle text-webbtree-green" type="button" id="userDropdownButton" (click)="changeContinent()"
          appDropdownToggle aria-haspopup="true" aria-expanded="false"><i class="fas fa-earth mr-1"></i><span
            class="text-capitalize mr-1">{{showregion == 'asia' ? 'Asia': showregion == 'africa'? 'Africa':
            showregion == 'north america' ? 'North America': showregion == 'oceania' ? 'Oceania': showregion == 'south america' ? 'South America': 'Europe'}}</span> <i class="fas fa-chevron-down f-14"></i>
        </button>
        <app-continent-selector [parentRegion]="showregion" class="dropdown-menu"
          aria-labelledby="userDropdownButton"></app-continent-selector>
      </span> -->
    </div>
    <div class="d-flex align-items-start">
      <div>
        <div style="width: 80px; margin-top: 5px;">
          Location
        </div>

      </div>
      <div class="w-100">
        <input data-testid="auto-app-talentpool-insights-input-4" type="text" name="" class="wc-form-control  no-shadow w-100 inputheight mb-2"
          (input)="onTypeAheadSearch($event, 'location')" placeholder="Enter Location" [formControl]="locationInput"
          [matAutocomplete]="location_auto"
          (blur)="removeTypeahead('location')">

        <mat-autocomplete #location_auto="matAutocomplete"
          (optionSelected)="selectedItem($event.option.value, 'location')">
          <mat-option *ngFor="let cl of locationList" [value]="cl" [disabled]="isLocationDisabled(cl)" [matTooltip]="getTooltipText(cl)" [matTooltipClass]="{ 'eu-tooltip text-black': true }" matTooltipPosition="above">
            {{cl.value | titlecase}}<span class="mt-1 f-12 text-9696 float-right">{{cl?.location_type}}</span>

          </mat-option>
        </mat-autocomplete>
        <div class="mt-2">
          <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let cl of locationSelectedList">
            <div class="d-flex">
              <span style="display: grid;">
                <span class="text-truncate">
                  {{cl?.chipkey | titlecase}}
                </span>
              </span>
              <span class="ml-2 pointer " (click)="removeChip(cl?.chipkey , 'location')">
                <i class="fal fa-times"></i></span>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div>
      <button data-testid="auto-app-talentpool-insights-button-3" class="btn-trms-medium ml-auto d-block"
        [ngClass]="{'disabled-button': (jobTitleSelectedList?.length == 0  && skillsSelectedList?.length == 0 && !this.keywordsearch)}"
        [disabled]="(jobTitleSelectedList?.length == 0  && skillsSelectedList?.length == 0 && !this.keywordsearch )"
        (click)="buildReport('redirect')"> <i class="fa-regular fa-file-chart-pie"></i> Build Report</button>
    </div>
  </div>
</ng-template>
